
import React from 'react';
import CampaignManagementCore from '../components/campaign_management/CampaignManagementCore';

const CampaignManagement = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <CampaignManagementCore />
    </div>
  );
};

export default CampaignManagement;
